import { DropdownOption } from '@products/types';

export interface EnvelopeTableData {
  year: number;
  data: {
    amount: number;
    showImage?: boolean;
  }[];
}

export class CalculatorUtility {
  public static getTaxRateRange(): DropdownOption[] {
    return [
      {
        value: '1',
        label: '24%',
      },
      {
        value: '2',
        label: '32%',
      },
      {
        value: '3',
        label: '35%',
      },
      {
        value: '4',
        label: '37%',
      },
    ];
  }

  public static getHypoRange(): DropdownOption[] {
    return [
      {
        value: '2',
        label: '2%',
      },
      {
        value: '2.5',
        label: '2.5%',
      },
      {
        value: '3',
        label: '3%',
      },
      {
        value: '3.5',
        label: '3.5%',
      },
      {
        value: '4',
        label: '4%',
      },
      {
        value: '4.5',
        label: '4.5%',
      },
    ];
  }

  public static getStateRange(): DropdownOption[] {
    return [
      {
        value: 'AL',
        label: 'AL',
      },
      {
        value: 'AK',
        label: 'AK',
      },
      {
        value: 'AZ',
        label: 'AZ',
      },
      {
        value: 'AR',
        label: 'AR',
      },
      {
        value: 'CA',
        label: 'CA',
      },
      {
        value: 'CO',
        label: 'CO',
      },
      {
        value: 'CT',
        label: 'CT',
      },
      {
        value: 'DE',
        label: 'DE',
      },
      {
        value: 'DC',
        label: 'DC',
      },
      {
        value: 'FL',
        label: 'FL',
      },
      {
        value: 'GA',
        label: 'GA',
      },
      {
        value: 'HI',
        label: 'HI',
      },
      {
        value: 'ID',
        label: 'ID',
      },
      {
        value: 'IL',
        label: 'IL',
      },
      {
        value: 'IN',
        label: 'IN',
      },
      {
        value: 'IA',
        label: 'IA',
      },
      {
        value: 'KS',
        label: 'KS',
      },
      {
        value: 'KY',
        label: 'KY',
      },
      {
        value: 'LA',
        label: 'LA',
      },
      {
        value: 'ME',
        label: 'ME',
      },
      {
        value: 'MD',
        label: 'MD',
      },
      {
        value: 'MA',
        label: 'MA',
      },
      {
        value: 'MI',
        label: 'MI',
      },
      {
        value: 'MN',
        label: 'MN',
      },
      {
        value: 'MS',
        label: 'MS',
      },
      {
        value: 'MO',
        label: 'MO',
      },
      {
        value: 'MT',
        label: 'MT',
      },
      {
        value: 'NE',
        label: 'NE',
      },
      {
        value: 'NV',
        label: 'NV',
      },
      {
        value: 'NH',
        label: 'NH',
      },
      {
        value: 'NJ',
        label: 'NJ',
      },
      {
        value: 'NM',
        label: 'NM',
      },
      {
        value: 'NYC',
        label: 'NYC',
      },
      {
        value: 'NY',
        label: 'NY',
      },
      {
        value: 'NC',
        label: 'NC',
      },
      {
        value: 'ND',
        label: 'ND',
      },
      {
        value: 'OH',
        label: 'OH',
      },
      {
        value: 'OK',
        label: 'OK',
      },
      {
        value: 'OR',
        label: 'OR',
      },
      {
        value: 'PA',
        label: 'PA',
      },
      {
        value: 'RI',
        label: 'RI',
      },
      {
        value: 'SC',
        label: 'SC',
      },
      {
        value: 'SD',
        label: 'SD',
      },
      {
        value: 'TN',
        label: 'TN',
      },
      {
        value: 'TX',
        label: 'TX',
      },
      {
        value: 'UT',
        label: 'UT',
      },
      {
        value: 'VT',
        label: 'VT',
      },
      {
        value: 'VA',
        label: 'VA',
      },
      {
        value: 'WA',
        label: 'WA',
      },
      {
        value: 'WV',
        label: 'WV',
      },
      {
        value: 'WI',
        label: 'WI',
      },
      {
        value: 'WY',
        label: 'WY',
      },
    ];
  }

  public static getTaxTable(): any[] {
    const stateTaxRange: any = [];

    stateTaxRange.AL = [
      ['5.0000', '5.0000', '5.0000', '5.0000'],
      ['32.8000', '40.8000', '43.8000', '45.8000'],
    ];
    stateTaxRange.AK = [
      ['0.0000', '0.0000', '0.0000', '0.0000'],
      ['27.8000', '35.8000', '38.8000', '40.8000'],
    ];
    stateTaxRange.AZ = [
      ['4.5400', '4.5400', '4.5400', '4.5400'],
      ['32.3400', '40.3400', '43.3400', '45.3400'],
    ];
    stateTaxRange.AR = [
      ['6.9000', '6.9000', '6.9000', '6.9000'],
      ['34.7000', '42.7000', '45.7000', '47.7000'],
    ];
    stateTaxRange.CA = [
      ['9.3000', '9.3000', '10.3000', '12.3000'],
      ['37.1000', '45.1000', '49.1000', '53.1000'],
    ];
    stateTaxRange.CO = [
      ['4.6300', '4.6300', '4.6300', '4.6300'],
      ['32.4300', '40.4300', '43.4300', '45.4300'],
    ];
    stateTaxRange.CT = [
      ['6.0000', '6.5000', '6.9000', '6.9900'],
      ['33.8000', '42.3000', '45.7000', '47.7900'],
    ];
    stateTaxRange.DE = [
      ['6.6000', '6.6000', '6.6000', '6.6000'],
      ['34.4000', '42.4000', '45.4000', '47.4000'],
    ];
    stateTaxRange.DC = [
      ['8.5000', '8.7500', '8.7500', '8.9500'],
      ['36.3000', '44.5500', '47.5500', '49.7500'],
    ];
    stateTaxRange.FL = [
      ['0.0000', '0.0000', '0.0000', '0.0000'],
      ['27.8000', '35.8000', '38.8000', '40.8000'],
    ];
    stateTaxRange.GA = [
      ['6.0000', '6.0000', '6.0000', '6.0000'],
      ['33.8000', '41.8000', '44.8000', '46.8000'],
    ];
    stateTaxRange.HI = [
      ['9.0000', '11.0000', '11.0000', '11.0000'],
      ['36.8000', '46.8000', '49.8000', '51.8000'],
    ];
    stateTaxRange.ID = [
      ['6.9250', '6.9250', '6.9250', '6.9250'],
      ['34.7250', '42.7250', '45.7250', '47.7250'],
    ];
    stateTaxRange.IL = [
      ['4.9500', '4.9500', '4.9500', '4.9500'],
      ['32.7500', '40.7500', '43.7500', '45.7500'],
    ];
    stateTaxRange.IN = [
      ['3.2300', '3.2300', '3.2300', '3.2300'],
      ['31.0300', '39.0300', '42.0300', '44.0300'],
    ];
    stateTaxRange.IA = [
      ['8.5300', '8.9800', '8.5300', '8.5300'],
      ['38.0360', '46.0360', '49.0360', '51.0360'],
    ];
    stateTaxRange.KS = [
      ['5.7000', '5.7000', '5.7000', '5.7000'],
      ['33.5000', '41.5000', '44.5000', '46.5000'],
    ];
    stateTaxRange.KY = [
      ['6.0000', '6.0000', '6.0000', '6.0000'],
      ['33.8000', '41.8000', '44.8000', '46.8000'],
    ];
    stateTaxRange.LA = [
      ['6.0000', '6.0000', '6.0000', '6.0000'],
      ['33.8000', '41.8000', '44.8000', '46.8000'],
    ];
    stateTaxRange.ME = [
      ['7.1500', '7.1500', '7.1500', '7.1500'],
      ['34.9500', '42.9500', '45.9500', '47.9500'],
    ];
    stateTaxRange.MD = [
      ['5.7500', '5.7500', '5.7500', '5.7500'],
      ['36.7500', '44.7500', '47.7500', '49.7500'],
    ];
    stateTaxRange.MA = [
      ['5.1000', '5.1000', '5.1000', '5.1000'],
      ['32.9000', '40.9000', '43.9000', '45.9000'],
    ];
    /*michigan*/
    stateTaxRange.MI = [
      ['4.2500', '4.2500', '4.2500', '4.2500'],
      ['32.0500', '40.0500', '43.0500', '45.0500'],
    ];
    /*minnesota*/
    stateTaxRange.MN = [
      ['9.8500', '9.8500', '9.8500', '9.8500'],
      ['37.6500', '45.6500', '48.6500', '50.6500'],
    ];
    /*mississippi*/
    stateTaxRange.MS = [
      ['5.0000', '5.0000', '5.0000', '5.0000'],
      ['32.8000', '40.8000', '43.8000', '45.8000'],
    ];
    /*missouri*/
    stateTaxRange.MO = [
      ['6.0000', '6.0000', '6.0000', '6.0000'],
      ['33.8000', '41.8000', '44.8000', '46.8000'],
    ];
    /*montana*/
    stateTaxRange.MT = [
      ['6.9000', '6.9000', '6.9000', '6.9000'],
      ['34.7000', '42.7000', '45.7000', '47.7000'],
    ];
    /*nebraska*/
    stateTaxRange.NE = [
      ['6.8400', '6.8400', '6.8400', '6.8400'],
      ['34.6400', '42.6400', '45.6400', '47.6400'],
    ];
    /*nevada*/
    stateTaxRange.NV = [
      ['0.0000', '0.0000', '0.0000', '0.0000'],
      ['27.8000', '35.8000', '38.8000', '40.8000'],
    ];
    /*new hampshire*/
    stateTaxRange.NH = [
      ['5.0000', '5.0000', '5.0000', '5.0000'],
      ['32.8000', '40.8000', '43.8000', '45.8000'],
    ];
    /*new jarsey*/
    stateTaxRange.NJ = [
      ['6.3700', '6.3700', '8.9700', '10.7500'],
      ['34.1700', '42.1700', '47.7700', '51.5500'],
    ];
    /*new mexico*/
    stateTaxRange.NM = [
      ['4.9000', '4.9000', '4.9000', '4.9000'],
      ['32.7000', '40.7000', '43.7000', '45.7000'],
    ];
    /*new jork*/
    stateTaxRange.NY = [
      ['6.4900', '6.8500', '6.8500', '8.8200'],
      ['34.2900', '42.6500', '45.6500', '49.6200'],
    ];
    /*new jork state and city*/
    stateTaxRange.NYC = [
      ['6.4900', '6.8500', '6.8500', '8.8200'],
      ['38.1660', '46.5260', '49.5260', '53.4960'],
    ];
    /*north carolina*/
    stateTaxRange.NC = [
      ['5.4990', '5.4990', '5.4990', '5.4990'],
      ['33.3000', '41.2990', '44.2990', '46.2990'],
    ];
    /*north dakota*/
    stateTaxRange.ND = [
      ['2.6400', '2.6400', '2.9000', '2.9000'],
      ['30.4400', '38.4400', '41.7000', '43.7000'],
    ];
    stateTaxRange.OH = [
      ['4.9970', '4.9970', '4.9970', '4.9970'],
      ['32.7970', '40.7970', '43.7970', '45.7970'],
    ];
    stateTaxRange.OK = [
      ['5.0000', '5.0000', '5.0000', '5.0000'],
      ['32.8000', '40.8000', '43.8000', '45.8000'],
    ];
    stateTaxRange.OR = [
      ['9.9000', '9.9000', '9.9000', '9.9000'],
      ['37.7000', '45.7000', '48.7000', '50.7000'],
    ];
    stateTaxRange.PA = [
      ['3.0700', '3.0700', '3.0700', '3.0700'],
      ['30.8700', '38.8700', '41.8700', '43.8700'],
    ];
    stateTaxRange.RI = [
      ['5.9900', '5.9900', '5.9900', '5.9900'],
      ['33.7900', '41.7900', '44.7900', '46.7900'],
    ];
    stateTaxRange.SC = [
      ['7.0000', '7.0000', '7.0000', '7.0000'],
      ['34.8000', '42.8000', '45.8000', '47.8000'],
    ];
    stateTaxRange.SD = [
      ['0.0000', '0.0000', '0.0000', '0.0000'],
      ['27.8000', '35.8000', '38.8000', '40.8000'],
    ];
    stateTaxRange.TN = [
      ['2.0000', '2.0000', '2.0000', '2.0000'],
      ['29.8000', '37.8000', '40.8000', '42.8000'],
    ];
    stateTaxRange.TX = [
      ['0.0000', '0.0000', '0.0000', '0.0000'],
      ['27.8000', '35.8000', '38.8000', '40.8000'],
    ];
    stateTaxRange.UT = [
      ['4.9500', '4.9500', '4.9500', '4.9500'],
      ['32.7500', '40.7500', '43.7500', '45.7500'],
    ];
    stateTaxRange.VT = [
      ['8.7500', '8.7500', '8.7500', '8.7500'],
      ['36.5500', '44.5500', '47.5500', '49.5500'],
    ];
    stateTaxRange.VA = [
      ['5.7500', '5.7500', '5.7500', '5.7500'],
      ['33.5500', '41.5500', '44.5500', '46.5500'],
    ];
    /*washington*/
    stateTaxRange.WA = [
      ['0.0000', '0.0000', '0.0000', '0.0000'],
      ['27.8000', '35.8000', '38.8000', '40.8000'],
    ];
    /*west virginia*/
    stateTaxRange.WV = [
      ['6.5000', '6.5000', '6.5000', '6.5000'],
      ['34.3000', '42.3000', '45.3000', '47.3000'],
    ];
    /*wisconsin*/
    stateTaxRange.WI = [
      ['6.2700', '7.6500', '7.6500', '7.6500'],
      ['34.0700', '43.45000', '46.45000', '48.45000'],
    ];
    /*wyoming*/
    stateTaxRange.WY = [
      ['0.0000', '0.0000', '0.0000', '0.0000'],
      ['27.8000', '35.8000', '38.8000', '40.8000'],
    ];

    return stateTaxRange;
  }

  public static getBeforeRetirementRates(): DropdownOption[] {
    return [
      {
        value: '4',
        label: '4%',
      },
      {
        value: '5',
        label: '5%',
      },
      {
        value: '6',
        label: '6%',
      },
      {
        value: '7',
        label: '7%',
      },
      {
        value: '8',
        label: '8%',
      },
      {
        value: '9',
        label: '9%',
      },
      {
        value: '10',
        label: '10%',
      },
      {
        value: '11',
        label: '11%',
      },
      {
        value: '12',
        label: '12%',
      },
    ];
  }

  public static getRetirementYears(): DropdownOption[] {
    return [
      {
        value: '1',
        label: '1',
      },
      {
        value: '2',
        label: '2',
      },
      {
        value: '3',
        label: '3',
      },
      {
        value: '4',
        label: '4',
      },
      {
        value: '5',
        label: '5',
      },
      {
        value: '6',
        label: '6',
      },
      {
        value: '7',
        label: '7',
      },
      {
        value: '8',
        label: '8',
      },
      {
        value: '9',
        label: '9',
      },
      {
        value: '10',
        label: '10',
      },
      {
        value: '11',
        label: '11',
      },
      {
        value: '12',
        label: '12',
      },
      {
        value: '12',
        label: '12',
      },
      {
        value: '13',
        label: '13',
      },
      {
        value: '14',
        label: '14',
      },
      {
        value: '15',
        label: '15',
      },
      {
        value: '16',
        label: '16',
      },
      {
        value: '17',
        label: '17',
      },
      {
        value: '18',
        label: '18',
      },
      {
        value: '19',
        label: '19',
      },
      {
        value: '20',
        label: '20',
      },
      {
        value: '21',
        label: '21',
      },
      {
        value: '22',
        label: '22',
      },
      {
        value: '23',
        label: '23',
      },
      {
        value: '24',
        label: '24',
      },
      {
        value: '25',
        label: '25',
      },
      {
        value: '26',
        label: '26',
      },
      {
        value: '27',
        label: '27',
      },
      {
        value: '28',
        label: '28',
      },
      {
        value: '29',
        label: '29',
      },
      {
        value: '30',
        label: '30',
      },
    ];
  }

  public static getIraFedTaxRates(): DropdownOption[] {
    return [
      {
        value: '10',
        label: '10%',
      },
      {
        value: '15',
        label: '15%',
      },
      {
        value: '25',
        label: '25%',
      },
      {
        value: '28',
        label: '28%',
      },
      {
        value: '33',
        label: '33%',
      },
      {
        value: '35',
        label: '35%',
      },
    ];
  }

  public static nextNearest(value: number, num: number): number {
    return Math.round(value * num) / num;
  }

  /**
   *
   * @param step Input to roundOff for given index
   * @returns Index to array after rounding off
   */
  private static roundStep(step: number): number {
    return Math.round(+(step * 100) - 2);
  }

  public static getFutureValueFactorsStep11(
    step3: number,
    step5: number
  ): number {
    // // Future Value Factors - Years to Retirement Data 2%, 3%, 4%, ....
    const YTRFVF1 = [
      1.02,
      1.03,
      1.04,
      1.05,
      1.06,
      1.07,
      1.08,
      1.09,
      1.1,
      1.11,
      1.12,
    ];
    const YTRFVF2 = [
      1.04,
      1.06,
      1.08,
      1.1,
      1.12,
      1.14,
      1.17,
      1.19,
      1.21,
      1.23,
      1.25,
    ];
    const YTRFVF3 = [
      1.06,
      1.09,
      1.12,
      1.16,
      1.19,
      1.23,
      1.26,
      1.3,
      1.33,
      1.37,
      1.4,
    ];
    const YTRFVF4 = [
      1.08,
      1.13,
      1.17,
      1.22,
      1.26,
      1.31,
      1.36,
      1.41,
      1.46,
      1.52,
      1.57,
    ];
    const YTRFVF5 = [
      1.1,
      1.16,
      1.22,
      1.28,
      1.34,
      1.4,
      1.47,
      1.54,
      1.61,
      1.69,
      1.76,
    ];
    const YTRFVF6 = [
      1.13,
      1.19,
      1.27,
      1.34,
      1.42,
      1.5,
      1.59,
      1.68,
      1.77,
      1.87,
      1.97,
    ];
    const YTRFVF7 = [
      1.15,
      1.23,
      1.32,
      1.41,
      1.5,
      1.61,
      1.71,
      1.83,
      1.95,
      2.08,
      2.21,
    ];
    const YTRFVF8 = [
      1.17,
      1.27,
      1.37,
      1.48,
      1.59,
      1.72,
      1.85,
      1.99,
      2.14,
      2.3,
      2.48,
    ];
    const YTRFVF9 = [
      1.2,
      1.3,
      1.42,
      1.55,
      1.69,
      1.84,
      2,
      2.17,
      2.36,
      2.56,
      2.77,
    ];
    const YTRFVF10 = [
      1.22,
      1.34,
      1.48,
      1.63,
      1.79,
      1.97,
      2.16,
      2.37,
      2.59,
      2.84,
      3.11,
    ];
    const YTRFVF11 = [
      1.24,
      1.38,
      1.54,
      1.71,
      1.9,
      2.1,
      2.33,
      2.58,
      2.85,
      3.15,
      3.48,
    ];
    const YTRFVF12 = [
      1.27,
      1.43,
      1.6,
      1.8,
      2.01,
      2.25,
      2.52,
      2.81,
      3.14,
      3.5,
      3.9,
    ];
    const YTRFVF13 = [
      1.29,
      1.47,
      1.67,
      1.89,
      2.13,
      2.41,
      2.72,
      3.07,
      3.45,
      3.88,
      4.36,
    ];
    const YTRFVF14 = [
      1.32,
      1.51,
      1.73,
      1.98,
      2.26,
      2.58,
      2.94,
      3.34,
      3.8,
      4.31,
      4.89,
    ];
    const YTRFVF15 = [
      1.35,
      1.56,
      1.8,
      2.08,
      2.4,
      2.76,
      3.17,
      3.64,
      4.18,
      4.78,
      5.47,
    ];
    const YTRFVF16 = [
      1.37,
      1.6,
      1.87,
      2.18,
      2.54,
      2.95,
      3.43,
      3.97,
      4.59,
      5.31,
      6.13,
    ];
    const YTRFVF17 = [
      1.4,
      1.65,
      1.95,
      2.29,
      2.69,
      3.16,
      3.7,
      4.33,
      5.05,
      5.9,
      6.87,
    ];
    const YTRFVF18 = [
      1.43,
      1.7,
      2.03,
      2.41,
      2.85,
      3.38,
      4.0,
      4.72,
      5.56,
      6.54,
      7.69,
    ];
    const YTRFVF19 = [
      1.46,
      1.75,
      2.11,
      2.53,
      3.03,
      3.62,
      4.32,
      5.14,
      6.12,
      7.26,
      8.61,
    ];
    const YTRFVF20 = [
      1.49,
      1.81,
      2.19,
      2.65,
      3.21,
      3.87,
      4.66,
      5.6,
      6.73,
      8.06,
      9.65,
    ];
    const YTRFVF21 = [
      1.52,
      1.86,
      2.28,
      2.79,
      3.4,
      4.14,
      5.03,
      6.11,
      7.4,
      8.95,
      10.8,
    ];
    const YTRFVF22 = [
      1.55,
      1.92,
      2.37,
      2.93,
      3.6,
      4.43,
      5.44,
      6.66,
      8.14,
      9.93,
      12.1,
    ];
    const YTRFVF23 = [
      1.58,
      1.97,
      2.46,
      3.07,
      3.82,
      4.74,
      5.87,
      7.26,
      8.95,
      11.03,
      13.55,
    ];
    const YTRFVF24 = [
      1.61,
      2.03,
      2.56,
      3.23,
      4.05,
      5.07,
      6.34,
      7.91,
      9.85,
      12.24,
      15.18,
    ];
    const YTRFVF25 = [
      1.64,
      2.09,
      2.67,
      3.39,
      4.29,
      5.43,
      6.85,
      8.62,
      10.83,
      13.59,
      17.0,
    ];
    const YTRFVF26 = [
      1.67,
      2.16,
      2.77,
      3.56,
      4.55,
      5.81,
      7.4,
      9.4,
      11.92,
      15.08,
      19.04,
    ];
    const YTRFVF27 = [
      1.71,
      2.22,
      2.88,
      3.73,
      4.82,
      6.21,
      7.99,
      10.25,
      13.11,
      16.74,
      21.32,
    ];
    const YTRFVF28 = [
      1.74,
      2.29,
      3.0,
      3.92,
      5.11,
      6.65,
      8.63,
      11.17,
      14.42,
      18.58,
      23.88,
    ];
    const YTRFVF29 = [
      1.78,
      2.36,
      3.12,
      4.12,
      5.42,
      7.11,
      9.32,
      12.17,
      15.86,
      20.62,
      26.75,
    ];
    const YTRFVF30 = [
      1.81,
      2.43,
      3.24,
      4.32,
      5.74,
      7.61,
      10.06,
      13.27,
      17.45,
      22.89,
      29.96,
    ];

    let step11;

    switch (step5) {
      case 1:
        step11 = YTRFVF1[CalculatorUtility.roundStep(step3)];
        break;

      case 2:
        step11 = YTRFVF2[CalculatorUtility.roundStep(step3)];
        break;

      case 3:
        step11 = YTRFVF3[CalculatorUtility.roundStep(step3)];
        break;

      case 4:
        step11 = YTRFVF4[CalculatorUtility.roundStep(step3)];
        break;

      case 5:
        step11 = YTRFVF5[CalculatorUtility.roundStep(step3)];
        break;

      case 6:
        step11 = YTRFVF6[CalculatorUtility.roundStep(step3)];
        break;

      case 7:
        step11 = YTRFVF7[CalculatorUtility.roundStep(step3)];
        break;

      case 8:
        step11 = YTRFVF8[CalculatorUtility.roundStep(step3)];
        break;

      case 9:
        step11 = YTRFVF9[CalculatorUtility.roundStep(step3)];
        break;

      case 10:
        step11 = YTRFVF10[CalculatorUtility.roundStep(step3)];
        break;

      case 11:
        step11 = YTRFVF11[CalculatorUtility.roundStep(step3)];
        break;

      case 12:
        step11 = YTRFVF12[CalculatorUtility.roundStep(step3)];
        break;

      case 13:
        step11 = YTRFVF13[CalculatorUtility.roundStep(step3)];
        break;

      case 14:
        step11 = YTRFVF14[CalculatorUtility.roundStep(step3)];
        break;

      case 15:
        step11 = YTRFVF15[CalculatorUtility.roundStep(step3)];
        break;

      case 16:
        step11 = YTRFVF16[CalculatorUtility.roundStep(step3)];
        break;

      case 17:
        step11 = YTRFVF17[CalculatorUtility.roundStep(step3)];
        break;

      case 18:
        step11 = YTRFVF18[CalculatorUtility.roundStep(step3)];
        break;

      case 19:
        step11 = YTRFVF19[CalculatorUtility.roundStep(step3)];
        break;

      case 20:
        step11 = YTRFVF20[CalculatorUtility.roundStep(step3)];
        break;

      case 21:
        step11 = YTRFVF21[CalculatorUtility.roundStep(step3)];
        break;

      case 22:
        step11 = YTRFVF22[CalculatorUtility.roundStep(step3)];
        break;

      case 23:
        step11 = YTRFVF23[CalculatorUtility.roundStep(step3)];
        break;

      case 24:
        step11 = YTRFVF24[CalculatorUtility.roundStep(step3)];
        break;

      case 25:
        step11 = YTRFVF25[CalculatorUtility.roundStep(step3)];
        break;

      case 26:
        step11 = YTRFVF26[CalculatorUtility.roundStep(step3)];
        break;

      case 27:
        step11 = YTRFVF27[CalculatorUtility.roundStep(step3)];
        break;

      case 28:
        step11 = YTRFVF28[CalculatorUtility.roundStep(step3)];
        break;

      case 29:
        step11 = YTRFVF29[CalculatorUtility.roundStep(step3)];
        break;

      case 30:
        step11 = YTRFVF30[CalculatorUtility.roundStep(step3)];
        break;
    }

    return step11;
  }

  public static getFutureValueFactorsStep12(
    step5: number,
    step9: number
  ): number {
    // // Future Value Factors - Years to Retirement Data 2%, 3%, 4%, ....
    const YTRFVF1 = [
      1.02,
      1.03,
      1.04,
      1.05,
      1.06,
      1.07,
      1.08,
      1.09,
      1.1,
      1.11,
      1.12,
    ];
    const YTRFVF2 = [
      1.04,
      1.06,
      1.08,
      1.1,
      1.12,
      1.14,
      1.17,
      1.19,
      1.21,
      1.23,
      1.25,
    ];
    const YTRFVF3 = [
      1.06,
      1.09,
      1.12,
      1.16,
      1.19,
      1.23,
      1.26,
      1.3,
      1.33,
      1.37,
      1.4,
    ];
    const YTRFVF4 = [
      1.08,
      1.13,
      1.17,
      1.22,
      1.26,
      1.31,
      1.36,
      1.41,
      1.46,
      1.52,
      1.57,
    ];
    const YTRFVF5 = [
      1.1,
      1.16,
      1.22,
      1.28,
      1.34,
      1.4,
      1.47,
      1.54,
      1.61,
      1.69,
      1.76,
    ];
    const YTRFVF6 = [
      1.13,
      1.19,
      1.27,
      1.34,
      1.42,
      1.5,
      1.59,
      1.68,
      1.77,
      1.87,
      1.97,
    ];
    const YTRFVF7 = [
      1.15,
      1.23,
      1.32,
      1.41,
      1.5,
      1.61,
      1.71,
      1.83,
      1.95,
      2.08,
      2.21,
    ];
    const YTRFVF8 = [
      1.17,
      1.27,
      1.37,
      1.48,
      1.59,
      1.72,
      1.85,
      1.99,
      2.14,
      2.3,
      2.48,
    ];
    const YTRFVF9 = [
      1.2,
      1.3,
      1.42,
      1.55,
      1.69,
      1.84,
      2,
      2.17,
      2.36,
      2.56,
      2.77,
    ];
    const YTRFVF10 = [
      1.22,
      1.34,
      1.48,
      1.63,
      1.79,
      1.97,
      2.16,
      2.37,
      2.59,
      2.84,
      3.11,
    ];
    const YTRFVF11 = [
      1.24,
      1.38,
      1.54,
      1.71,
      1.9,
      2.1,
      2.33,
      2.58,
      2.85,
      3.15,
      3.48,
    ];
    const YTRFVF12 = [
      1.27,
      1.43,
      1.6,
      1.8,
      2.01,
      2.25,
      2.52,
      2.81,
      3.14,
      3.5,
      3.9,
    ];
    const YTRFVF13 = [
      1.29,
      1.47,
      1.67,
      1.89,
      2.13,
      2.41,
      2.72,
      3.07,
      3.45,
      3.88,
      4.36,
    ];
    const YTRFVF14 = [
      1.32,
      1.51,
      1.73,
      1.98,
      2.26,
      2.58,
      2.94,
      3.34,
      3.8,
      4.31,
      4.89,
    ];
    const YTRFVF15 = [
      1.35,
      1.56,
      1.8,
      2.08,
      2.4,
      2.76,
      3.17,
      3.64,
      4.18,
      4.78,
      5.47,
    ];
    const YTRFVF16 = [
      1.37,
      1.6,
      1.87,
      2.18,
      2.54,
      2.95,
      3.43,
      3.97,
      4.59,
      5.31,
      6.13,
    ];
    const YTRFVF17 = [
      1.4,
      1.65,
      1.95,
      2.29,
      2.69,
      3.16,
      3.7,
      4.33,
      5.05,
      5.9,
      6.87,
    ];
    const YTRFVF18 = [
      1.43,
      1.7,
      2.03,
      2.41,
      2.85,
      3.38,
      4.0,
      4.72,
      5.56,
      6.54,
      7.69,
    ];
    const YTRFVF19 = [
      1.46,
      1.75,
      2.11,
      2.53,
      3.03,
      3.62,
      4.32,
      5.14,
      6.12,
      7.26,
      8.61,
    ];
    const YTRFVF20 = [
      1.49,
      1.81,
      2.19,
      2.65,
      3.21,
      3.87,
      4.66,
      5.6,
      6.73,
      8.06,
      9.65,
    ];
    const YTRFVF21 = [
      1.52,
      1.86,
      2.28,
      2.79,
      3.4,
      4.14,
      5.03,
      6.11,
      7.4,
      8.95,
      10.8,
    ];
    const YTRFVF22 = [
      1.55,
      1.92,
      2.37,
      2.93,
      3.6,
      4.43,
      5.44,
      6.66,
      8.14,
      9.93,
      12.1,
    ];
    const YTRFVF23 = [
      1.58,
      1.97,
      2.46,
      3.07,
      3.82,
      4.74,
      5.87,
      7.26,
      8.95,
      11.03,
      13.55,
    ];
    const YTRFVF24 = [
      1.61,
      2.03,
      2.56,
      3.23,
      4.05,
      5.07,
      6.34,
      7.91,
      9.85,
      12.24,
      15.18,
    ];
    const YTRFVF25 = [
      1.64,
      2.09,
      2.67,
      3.39,
      4.29,
      5.43,
      6.85,
      8.62,
      10.83,
      13.59,
      17.0,
    ];
    const YTRFVF26 = [
      1.67,
      2.16,
      2.77,
      3.56,
      4.55,
      5.81,
      7.4,
      9.4,
      11.92,
      15.08,
      19.04,
    ];
    const YTRFVF27 = [
      1.71,
      2.22,
      2.88,
      3.73,
      4.82,
      6.21,
      7.99,
      10.25,
      13.11,
      16.74,
      21.32,
    ];
    const YTRFVF28 = [
      1.74,
      2.29,
      3.0,
      3.92,
      5.11,
      6.65,
      8.63,
      11.17,
      14.42,
      18.58,
      23.88,
    ];
    const YTRFVF29 = [
      1.78,
      2.36,
      3.12,
      4.12,
      5.42,
      7.11,
      9.32,
      12.17,
      15.86,
      20.62,
      26.75,
    ];
    const YTRFVF30 = [
      1.81,
      2.43,
      3.24,
      4.32,
      5.74,
      7.61,
      10.06,
      13.27,
      17.45,
      22.89,
      29.96,
    ];

    let step12;

    switch (step5) {
      case 1:
        step12 = YTRFVF1[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 2:
        step12 = YTRFVF2[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 3:
        step12 = YTRFVF3[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 4:
        step12 = YTRFVF4[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 5:
        step12 = YTRFVF5[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 6:
        step12 = YTRFVF6[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 7:
        step12 = YTRFVF7[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 8:
        step12 = YTRFVF8[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 9:
        step12 = YTRFVF9[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 10:
        step12 = YTRFVF10[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 11:
        step12 = YTRFVF11[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 12:
        step12 = YTRFVF12[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 13:
        step12 = YTRFVF13[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 14:
        step12 = YTRFVF14[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 15:
        step12 = YTRFVF15[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 16:
        step12 = YTRFVF16[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 17:
        step12 = YTRFVF17[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 18:
        step12 = YTRFVF18[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 19:
        step12 = YTRFVF19[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 20:
        step12 = YTRFVF20[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 21:
        step12 = YTRFVF21[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 22:
        step12 = YTRFVF22[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 23:
        step12 = YTRFVF23[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 24:
        step12 = YTRFVF24[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 25:
        step12 = YTRFVF25[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 26:
        step12 = YTRFVF26[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 27:
        step12 = YTRFVF27[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 28:
        step12 = YTRFVF28[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 29:
        step12 = YTRFVF29[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;

      case 30:
        step12 = YTRFVF30[CalculatorUtility.nextNearest(step9 * 100, 1) - 2];
        break;
    }

    return step12;
  }

  public static getIncomeFactorsStep13(step4: number, step6: number) {
    // Income Factors - Years to Retirement Data 2%, 3%, 4%, ....
    const YTRIF1 = [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0];
    const YTRIF2 = [
      1.98,
      1.97,
      1.96,
      1.95,
      1.94,
      1.93,
      1.93,
      1.92,
      1.91,
      1.9,
      1.89,
    ];
    const YTRIF3 = [
      2.94,
      2.91,
      2.89,
      2.86,
      2.83,
      2.81,
      2.78,
      2.76,
      2.74,
      2.71,
      2.69,
    ];
    const YTRIF4 = [
      3.88,
      3.83,
      3.78,
      3.72,
      3.67,
      3.62,
      3.58,
      3.53,
      3.49,
      3.44,
      3.4,
    ];
    const YTRIF5 = [
      4.81,
      4.72,
      4.63,
      4.55,
      4.47,
      4.39,
      4.31,
      4.24,
      4.17,
      4.1,
      4.04,
    ];
    const YTRIF6 = [
      5.71,
      5.58,
      5.45,
      5.33,
      5.21,
      5.1,
      4.99,
      4.89,
      4.79,
      4.7,
      4.6,
    ];
    const YTRIF7 = [
      6.6,
      6.42,
      6.24,
      6.08,
      5.92,
      5.77,
      5.62,
      5.49,
      5.36,
      5.23,
      5.11,
    ];
    const YTRIF8 = [
      7.47,
      7.23,
      7.0,
      6.79,
      6.58,
      6.39,
      6.21,
      6.03,
      5.87,
      5.71,
      5.56,
    ];
    const YTRIF9 = [
      8.33,
      8.02,
      7.73,
      7.46,
      7.21,
      6.97,
      6.75,
      6.53,
      6.33,
      6.15,
      5.97,
    ];
    const YTRIF10 = [
      9.16,
      8.79,
      8.44,
      8.11,
      7.8,
      7.52,
      7.25,
      7.0,
      6.76,
      6.54,
      6.33,
    ];
    const YTRIF11 = [
      9.98,
      9.53,
      9.11,
      8.72,
      8.36,
      8.02,
      7.71,
      7.42,
      7.14,
      6.89,
      6.65,
    ];
    const YTRIF12 = [
      10.79,
      10.25,
      9.76,
      9.31,
      8.89,
      8.5,
      8.14,
      7.81,
      7.5,
      7.21,
      6.94,
    ];
    const YTRIF13 = [
      11.58,
      10.95,
      10.39,
      9.86,
      9.38,
      8.94,
      8.54,
      8.16,
      7.81,
      7.49,
      7.19,
    ];
    const YTRIF14 = [
      12.35,
      11.63,
      10.99,
      10.39,
      9.85,
      9.36,
      8.9,
      8.49,
      8.1,
      7.75,
      7.42,
    ];
    const YTRIF15 = [
      13.11,
      12.3,
      11.56,
      10.9,
      10.29,
      9.75,
      9.24,
      8.79,
      8.37,
      7.98,
      7.63,
    ];
    const YTRIF16 = [
      13.85,
      12.94,
      12.12,
      11.38,
      10.71,
      10.11,
      9.56,
      9.06,
      8.61,
      8.19,
      7.81,
    ];
    const YTRIF17 = [
      14.58,
      13.56,
      12.65,
      11.84,
      11.11,
      10.45,
      9.85,
      9.31,
      8.82,
      8.38,
      7.97,
    ];
    const YTRIF18 = [
      15.29,
      14.17,
      13.17,
      12.27,
      11.48,
      10.76,
      10.12,
      9.54,
      9.02,
      8.55,
      8.12,
    ];
    const YTRIF19 = [
      15.99,
      14.75,
      13.66,
      12.69,
      11.83,
      11.06,
      10.37,
      9.76,
      9.2,
      8.7,
      8.25,
    ];
    const YTRIF20 = [
      16.68,
      15.32,
      14.13,
      13.09,
      12.16,
      11.34,
      10.6,
      9.95,
      9.36,
      8.84,
      8.37,
    ];
    const YTRIF21 = [
      17.35,
      15.88,
      14.59,
      13.46,
      12.47,
      11.59,
      10.82,
      10.13,
      9.51,
      8.96,
      8.47,
    ];
    const YTRIF22 = [
      18.01,
      16.42,
      15.03,
      13.82,
      12.76,
      11.84,
      11.02,
      10.29,
      9.65,
      9.08,
      8.56,
    ];
    const YTRIF23 = [
      18.66,
      16.94,
      15.45,
      14.16,
      13.04,
      12.06,
      11.2,
      10.44,
      9.77,
      9.18,
      8.64,
    ];
    const YTRIF24 = [
      19.29,
      17.44,
      15.86,
      14.49,
      13.3,
      12.27,
      11.37,
      10.58,
      9.88,
      9.27,
      8.72,
    ];
    const YTRIF25 = [
      19.91,
      17.94,
      16.25,
      14.8,
      13.55,
      12.47,
      11.53,
      10.71,
      9.98,
      9.35,
      8.78,
    ];
    const YTRIF26 = [
      20.52,
      18.41,
      16.62,
      15.09,
      13.78,
      12.65,
      11.67,
      10.82,
      10.08,
      9.42,
      8.84,
    ];
    const YTRIF27 = [
      21.12,
      18.88,
      16.98,
      15.38,
      14.0,
      12.83,
      11.81,
      10.93,
      10.16,
      9.49,
      8.9,
    ];
    const YTRIF28 = [
      21.71,
      19.33,
      17.33,
      15.64,
      14.21,
      12.99,
      11.94,
      11.03,
      10.24,
      9.55,
      8.94,
    ];
    const YTRIF29 = [
      22.28,
      19.76,
      17.66,
      15.9,
      14.41,
      13.14,
      12.05,
      11.12,
      10.31,
      9.6,
      8.98,
    ];
    const YTRIF30 = [
      22.84,
      20.19,
      17.98,
      16.14,
      14.59,
      13.28,
      12.16,
      11.2,
      10.37,
      9.65,
      9.02,
    ];

    let step13;

    switch (step6) {
      case 1:
        step13 = YTRIF1[CalculatorUtility.roundStep(step4)];
        break;

      case 2:
        step13 = YTRIF2[CalculatorUtility.roundStep(step4)];
        break;

      case 3:
        step13 = YTRIF3[CalculatorUtility.roundStep(step4)];
        break;

      case 4:
        step13 = YTRIF4[CalculatorUtility.roundStep(step4)];
        break;

      case 5:
        step13 = YTRIF5[CalculatorUtility.roundStep(step4)];
        break;

      case 6:
        step13 = YTRIF6[CalculatorUtility.roundStep(step4)];
        break;

      case 7:
        step13 = YTRIF7[CalculatorUtility.roundStep(step4)];
        break;

      case 8:
        step13 = YTRIF8[CalculatorUtility.roundStep(step4)];
        break;

      case 9:
        step13 = YTRIF9[CalculatorUtility.roundStep(step4)];
        break;

      case 10:
        step13 = YTRIF10[CalculatorUtility.roundStep(step4)];
        break;

      case 11:
        step13 = YTRIF11[CalculatorUtility.roundStep(step4)];
        break;

      case 12:
        step13 = YTRIF12[CalculatorUtility.roundStep(step4)];
        break;

      case 13:
        step13 = YTRIF13[CalculatorUtility.roundStep(step4)];
        break;

      case 14:
        step13 = YTRIF14[CalculatorUtility.roundStep(step4)];
        break;

      case 15:
        step13 = YTRIF15[CalculatorUtility.roundStep(step4)];
        break;

      case 16:
        step13 = YTRIF16[CalculatorUtility.roundStep(step4)];
        break;

      case 17:
        step13 = YTRIF17[CalculatorUtility.roundStep(step4)];
        break;

      case 18:
        step13 = YTRIF18[CalculatorUtility.roundStep(step4)];
        break;

      case 19:
        step13 = YTRIF19[CalculatorUtility.roundStep(step4)];
        break;

      case 20:
        step13 = YTRIF20[CalculatorUtility.roundStep(step4)];
        break;

      case 21:
        step13 = YTRIF21[CalculatorUtility.roundStep(step4)];
        break;

      case 22:
        step13 = YTRIF22[CalculatorUtility.roundStep(step4)];
        break;

      case 23:
        step13 = YTRIF23[CalculatorUtility.roundStep(step4)];
        break;

      case 24:
        step13 = YTRIF24[CalculatorUtility.roundStep(step4)];
        break;

      case 25:
        step13 = YTRIF25[CalculatorUtility.roundStep(step4)];
        break;

      case 26:
        step13 = YTRIF26[CalculatorUtility.roundStep(step4)];
        break;

      case 27:
        step13 = YTRIF27[CalculatorUtility.roundStep(step4)];
        break;

      case 28:
        step13 = YTRIF28[CalculatorUtility.roundStep(step4)];
        break;

      case 29:
        step13 = YTRIF29[CalculatorUtility.roundStep(step4)];
        break;

      case 30:
        step13 = YTRIF30[CalculatorUtility.roundStep(step4)];
        break;
    }

    return step13;
  }

  public static getIncomeFactorsStep14(step6: number, step10: number) {
    // Income Factors - Years to Retirement Data 2%, 3%, 4%, ....
    const YTRIF1 = [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0];
    const YTRIF2 = [
      1.98,
      1.97,
      1.96,
      1.95,
      1.94,
      1.93,
      1.93,
      1.92,
      1.91,
      1.9,
      1.89,
    ];
    const YTRIF3 = [
      2.94,
      2.91,
      2.89,
      2.86,
      2.83,
      2.81,
      2.78,
      2.76,
      2.74,
      2.71,
      2.69,
    ];
    const YTRIF4 = [
      3.88,
      3.83,
      3.78,
      3.72,
      3.67,
      3.62,
      3.58,
      3.53,
      3.49,
      3.44,
      3.4,
    ];
    const YTRIF5 = [
      4.81,
      4.72,
      4.63,
      4.55,
      4.47,
      4.39,
      4.31,
      4.24,
      4.17,
      4.1,
      4.04,
    ];
    const YTRIF6 = [
      5.71,
      5.58,
      5.45,
      5.33,
      5.21,
      5.1,
      4.99,
      4.89,
      4.79,
      4.7,
      4.6,
    ];
    const YTRIF7 = [
      6.6,
      6.42,
      6.24,
      6.08,
      5.92,
      5.77,
      5.62,
      5.49,
      5.36,
      5.23,
      5.11,
    ];
    const YTRIF8 = [
      7.47,
      7.23,
      7.0,
      6.79,
      6.58,
      6.39,
      6.21,
      6.03,
      5.87,
      5.71,
      5.56,
    ];
    const YTRIF9 = [
      8.33,
      8.02,
      7.73,
      7.46,
      7.21,
      6.97,
      6.75,
      6.53,
      6.33,
      6.15,
      5.97,
    ];
    const YTRIF10 = [
      9.16,
      8.79,
      8.44,
      8.11,
      7.8,
      7.52,
      7.25,
      7.0,
      6.76,
      6.54,
      6.33,
    ];
    const YTRIF11 = [
      9.98,
      9.53,
      9.11,
      8.72,
      8.36,
      8.02,
      7.71,
      7.42,
      7.14,
      6.89,
      6.65,
    ];
    const YTRIF12 = [
      10.79,
      10.25,
      9.76,
      9.31,
      8.89,
      8.5,
      8.14,
      7.81,
      7.5,
      7.21,
      6.94,
    ];
    const YTRIF13 = [
      11.58,
      10.95,
      10.39,
      9.86,
      9.38,
      8.94,
      8.54,
      8.16,
      7.81,
      7.49,
      7.19,
    ];
    const YTRIF14 = [
      12.35,
      11.63,
      10.99,
      10.39,
      9.85,
      9.36,
      8.9,
      8.49,
      8.1,
      7.75,
      7.42,
    ];
    const YTRIF15 = [
      13.11,
      12.3,
      11.56,
      10.9,
      10.29,
      9.75,
      9.24,
      8.79,
      8.37,
      7.98,
      7.63,
    ];
    const YTRIF16 = [
      13.85,
      12.94,
      12.12,
      11.38,
      10.71,
      10.11,
      9.56,
      9.06,
      8.61,
      8.19,
      7.81,
    ];
    const YTRIF17 = [
      14.58,
      13.56,
      12.65,
      11.84,
      11.11,
      10.45,
      9.85,
      9.31,
      8.82,
      8.38,
      7.97,
    ];
    const YTRIF18 = [
      15.29,
      14.17,
      13.17,
      12.27,
      11.48,
      10.76,
      10.12,
      9.54,
      9.02,
      8.55,
      8.12,
    ];
    const YTRIF19 = [
      15.99,
      14.75,
      13.66,
      12.69,
      11.83,
      11.06,
      10.37,
      9.76,
      9.2,
      8.7,
      8.25,
    ];
    const YTRIF20 = [
      16.68,
      15.32,
      14.13,
      13.09,
      12.16,
      11.34,
      10.6,
      9.95,
      9.36,
      8.84,
      8.37,
    ];
    const YTRIF21 = [
      17.35,
      15.88,
      14.59,
      13.46,
      12.47,
      11.59,
      10.82,
      10.13,
      9.51,
      8.96,
      8.47,
    ];
    const YTRIF22 = [
      18.01,
      16.42,
      15.03,
      13.82,
      12.76,
      11.84,
      11.02,
      10.29,
      9.65,
      9.08,
      8.56,
    ];
    const YTRIF23 = [
      18.66,
      16.94,
      15.45,
      14.16,
      13.04,
      12.06,
      11.2,
      10.44,
      9.77,
      9.18,
      8.64,
    ];
    const YTRIF24 = [
      19.29,
      17.44,
      15.86,
      14.49,
      13.3,
      12.27,
      11.37,
      10.58,
      9.88,
      9.27,
      8.72,
    ];
    const YTRIF25 = [
      19.91,
      17.94,
      16.25,
      14.8,
      13.55,
      12.47,
      11.53,
      10.71,
      9.98,
      9.35,
      8.78,
    ];
    const YTRIF26 = [
      20.52,
      18.41,
      16.62,
      15.09,
      13.78,
      12.65,
      11.67,
      10.82,
      10.08,
      9.42,
      8.84,
    ];
    const YTRIF27 = [
      21.12,
      18.88,
      16.98,
      15.38,
      14.0,
      12.83,
      11.81,
      10.93,
      10.16,
      9.49,
      8.9,
    ];
    const YTRIF28 = [
      21.71,
      19.33,
      17.33,
      15.64,
      14.21,
      12.99,
      11.94,
      11.03,
      10.24,
      9.55,
      8.94,
    ];
    const YTRIF29 = [
      22.28,
      19.76,
      17.66,
      15.9,
      14.41,
      13.14,
      12.05,
      11.12,
      10.31,
      9.6,
      8.98,
    ];
    const YTRIF30 = [
      22.84,
      20.19,
      17.98,
      16.14,
      14.59,
      13.28,
      12.16,
      11.2,
      10.37,
      9.65,
      9.02,
    ];

    let step14;

    switch (step6) {
      case 1:
        step14 = YTRIF1[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 2:
        step14 = YTRIF2[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 3:
        step14 = YTRIF3[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 4:
        step14 = YTRIF4[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 5:
        step14 = YTRIF5[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 6:
        step14 = YTRIF6[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 7:
        step14 = YTRIF7[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 8:
        step14 = YTRIF8[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 9:
        step14 = YTRIF9[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 10:
        step14 = YTRIF10[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 11:
        step14 = YTRIF11[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 12:
        step14 = YTRIF12[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 13:
        step14 = YTRIF13[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 14:
        step14 = YTRIF14[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 15:
        step14 = YTRIF15[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 16:
        step14 = YTRIF16[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 17:
        step14 = YTRIF17[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 18:
        step14 = YTRIF18[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 19:
        step14 = YTRIF19[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 20:
        step14 = YTRIF20[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 21:
        step14 = YTRIF21[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 22:
        step14 = YTRIF22[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 23:
        step14 = YTRIF23[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 24:
        step14 = YTRIF24[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 25:
        step14 = YTRIF25[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 26:
        step14 = YTRIF26[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 27:
        step14 = YTRIF27[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 28:
        step14 = YTRIF28[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 29:
        step14 = YTRIF29[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;

      case 30:
        step14 = YTRIF30[CalculatorUtility.nextNearest(step10 * 100, 1) - 2];
        break;
    }

    return step14;
  }

  public static getFutureValueAnnuity(
    rate: number,
    amount: number,
    years: number,
    fv?: number
  ): number {
    let instrestRate = rate;
    let monthCount = 0;
    let presentValue = 0;
    let futureVal = fv || 0;
    const noOfMonths = 12 * years;
    const ContribAmount = amount;
    for (
      instrestRate = instrestRate > 1 ? instrestRate / 100 : instrestRate,
        instrestRate /= 12;
      noOfMonths > monthCount;

    ) {
      presentValue = futureVal + ContribAmount;
      futureVal = presentValue * instrestRate + (futureVal + ContribAmount);
      monthCount += 1;
    }
    futureVal = futureVal;
    return Math.round(futureVal);
  }

  public static getEnvelopeTableMonths(model: any): string[] {
    return [
      '',
      model?.envelopeTableMonthJan,
      model?.envelopeTableMonthFeb,
      model?.envelopeTableMonthMar,
      model?.envelopeTableMonthApr,
      model?.envelopeTableMonthMay,
      model?.envelopeTableMonthJun,
      model?.envelopeTableMonthJul,
      model?.envelopeTableMonthAug,
      model?.envelopeTableMonthSep,
      model?.envelopeTableMonthOct,
      model?.envelopeTableMonthNov,
      model?.envelopeTableMonthDec,
    ];
  }
  public static setEnvelopeTableShowImage(
    colsData: EnvelopeTableData[],
    val: boolean
  ) {
    colsData.forEach((colData: EnvelopeTableData) => {
      colData.data.forEach((dataItem) => {
        dataItem.showImage = val;
      });
    });
  }
  public static getEnvelopeTableData(model: any): EnvelopeTableData[] {
    const data: EnvelopeTableData[] = [
      {
        year: 2001,
        data: [
          {
            amount: model?.envelopeTable2001Jan,
          },
          {
            amount: model?.envelopeTable2001Feb,
          },
          {
            amount: model?.envelopeTable2001Mar,
          },
          {
            amount: model?.envelopeTable2001Apr,
          },
          {
            amount: model?.envelopeTable2001May,
          },
          {
            amount: model?.envelopeTable2001Jun,
          },
          {
            amount: model?.envelopeTable2001Jul,
          },
          {
            amount: model?.envelopeTable2001Aug,
          },
          {
            amount: model?.envelopeTable2001Sep,
          },
          {
            amount: model?.envelopeTable2001Oct,
          },
          {
            amount: model?.envelopeTable2001Nov,
          },
          {
            amount: model?.envelopeTable2001Dec,
          },
        ],
      },
      {
        year: 2002,
        data: [
          {
            amount: model?.envelopeTable2002Jan,
          },
          {
            amount: model?.envelopeTable2002Feb,
          },
          {
            amount: model?.envelopeTable2002Mar,
          },
          {
            amount: model?.envelopeTable2002Apr,
          },
          {
            amount: model?.envelopeTable2002May,
          },
          {
            amount: model?.envelopeTable2002Jun,
          },
          {
            amount: model?.envelopeTable2002Jul,
          },
          {
            amount: model?.envelopeTable2002Aug,
          },
          {
            amount: model?.envelopeTable2002Sep,
          },
          {
            amount: model?.envelopeTable2002Oct,
          },
          {
            amount: model?.envelopeTable2002Nov,
          },
          {
            amount: model?.envelopeTable2002Dec,
          },
        ],
      },
      {
        year: 2003,
        data: [
          {
            amount: model?.envelopeTable2003Jan,
          },
          {
            amount: model?.envelopeTable2003Feb,
          },
          {
            amount: model?.envelopeTable2003Mar,
          },
          {
            amount: model?.envelopeTable2003Apr,
          },
          {
            amount: model?.envelopeTable2003May,
          },
          {
            amount: model?.envelopeTable2003Jun,
          },
          {
            amount: model?.envelopeTable2003Jul,
          },
          {
            amount: model?.envelopeTable2003Aug,
          },
          {
            amount: model?.envelopeTable2003Sep,
          },
          {
            amount: model?.envelopeTable2003Oct,
          },
          {
            amount: model?.envelopeTable2003Nov,
          },
          {
            amount: model?.envelopeTable2003Dec,
          },
        ],
      },
      {
        year: 2004,
        data: [
          {
            amount: model?.envelopeTable2004Jan,
          },
          {
            amount: model?.envelopeTable2004Feb,
          },
          {
            amount: model?.envelopeTable2004Mar,
          },
          {
            amount: model?.envelopeTable2004Apr,
          },
          {
            amount: model?.envelopeTable2004May,
          },
          {
            amount: model?.envelopeTable2004Jun,
          },
          {
            amount: model?.envelopeTable2004Jul,
          },
          {
            amount: model?.envelopeTable2004Aug,
          },
          {
            amount: model?.envelopeTable2004Sep,
          },
          {
            amount: model?.envelopeTable2004Oct,
          },
          {
            amount: model?.envelopeTable2004Nov,
          },
          {
            amount: model?.envelopeTable2004Dec,
          },
        ],
      },
      {
        year: 2005,
        data: [
          {
            amount: model?.envelopeTable2005Jan,
          },
          {
            amount: model?.envelopeTable2005Feb,
          },
          {
            amount: model?.envelopeTable2005Mar,
          },
          {
            amount: model?.envelopeTable2005Apr,
          },
          {
            amount: model?.envelopeTable2005May,
          },
          {
            amount: model?.envelopeTable2005Jun,
          },
          {
            amount: model?.envelopeTable2005Jul,
          },
          {
            amount: model?.envelopeTable2005Aug,
          },
          {
            amount: model?.envelopeTable2005Sep,
          },
          {
            amount: model?.envelopeTable2005Oct,
          },
          {
            amount: model?.envelopeTable2005Nov,
          },
          {
            amount: model?.envelopeTable2005Dec,
          },
        ],
      },
      {
        year: 2006,
        data: [
          {
            amount: model?.envelopeTable2006Jan,
          },
          {
            amount: model?.envelopeTable2006Feb,
          },
          {
            amount: model?.envelopeTable2006Mar,
          },
          {
            amount: model?.envelopeTable2006Apr,
          },
          {
            amount: model?.envelopeTable2006May,
          },
          {
            amount: model?.envelopeTable2006Jun,
          },
          {
            amount: model?.envelopeTable2006Jul,
          },
          {
            amount: model?.envelopeTable2006Aug,
          },
          {
            amount: model?.envelopeTable2006Sep,
          },
          {
            amount: model?.envelopeTable2006Oct,
          },
          {
            amount: model?.envelopeTable2006Nov,
          },
          {
            amount: model?.envelopeTable2006Dec,
          },
        ],
      },
      {
        year: 2007,
        data: [
          {
            amount: model?.envelopeTable2007Jan,
          },
          {
            amount: model?.envelopeTable2007Feb,
          },
          {
            amount: model?.envelopeTable2007Mar,
          },
          {
            amount: model?.envelopeTable2007Apr,
          },
          {
            amount: model?.envelopeTable2007May,
          },
          {
            amount: model?.envelopeTable2007Jun,
          },
          {
            amount: model?.envelopeTable2007Jul,
          },
          {
            amount: model?.envelopeTable2007Aug,
          },
          {
            amount: model?.envelopeTable2007Sep,
          },
          {
            amount: model?.envelopeTable2007Oct,
          },
          {
            amount: model?.envelopeTable2007Nov,
          },
          {
            amount: model?.envelopeTable2007Dec,
          },
        ],
      },
      {
        year: 2008,
        data: [
          {
            amount: model?.envelopeTable2008Jan,
          },
          {
            amount: model?.envelopeTable2008Feb,
          },
          {
            amount: model?.envelopeTable2008Mar,
          },
          {
            amount: model?.envelopeTable2008Apr,
          },
          {
            amount: model?.envelopeTable2008May,
          },
          {
            amount: model?.envelopeTable2008Jun,
          },
          {
            amount: model?.envelopeTable2008Jul,
          },
          {
            amount: model?.envelopeTable2008Aug,
          },
          {
            amount: model?.envelopeTable2008Sep,
          },
          {
            amount: model?.envelopeTable2008Oct,
          },
          {
            amount: model?.envelopeTable2008Nov,
          },
          {
            amount: model?.envelopeTable2008Dec,
          },
        ],
      },
      {
        year: 2009,
        data: [
          { amount: model?.envelopeTable2009Jan },
          { amount: model?.envelopeTable2009Feb },
          { amount: model?.envelopeTable2009Mar },
          { amount: model?.envelopeTable2009Apr },
          { amount: model?.envelopeTable2009May },
          { amount: model?.envelopeTable2009Jun },
          { amount: model?.envelopeTable2009Jul },
          { amount: model?.envelopeTable2009Aug },
          { amount: model?.envelopeTable2009Sep },
          { amount: model?.envelopeTable2009Oct },
          { amount: model?.envelopeTable2009Nov },
          { amount: model?.envelopeTable2009Dec },
        ],
      },
      {
        year: 2010,
        data: [
          { amount: model?.envelopeTable2010Jan },
          { amount: model?.envelopeTable2010Feb },
          { amount: model?.envelopeTable2010Mar },
          { amount: model?.envelopeTable2010Apr },
          { amount: model?.envelopeTable2010May },
          { amount: model?.envelopeTable2010Jun },
          { amount: model?.envelopeTable2010Jul },
          { amount: model?.envelopeTable2010Aug },
          { amount: model?.envelopeTable2010Sep },
          { amount: model?.envelopeTable2010Oct },
          { amount: model?.envelopeTable2010Nov },
          { amount: model?.envelopeTable2010Dec },
        ],
      },
      {
        year: 2011,
        data: [
          { amount: model?.envelopeTable2011Jan },
          { amount: model?.envelopeTable2011Feb },
          { amount: model?.envelopeTable2011Mar },
          { amount: model?.envelopeTable2011Apr },
          { amount: model?.envelopeTable2011May },
          { amount: model?.envelopeTable2011Jun },
          { amount: model?.envelopeTable2011Jul },
          { amount: model?.envelopeTable2011Aug },
          { amount: model?.envelopeTable2011Sep },
          { amount: model?.envelopeTable2011Oct },
          { amount: model?.envelopeTable2011Nov },
          { amount: model?.envelopeTable2011Dec },
        ],
      },
      {
        year: 2012,
        data: [
          { amount: model?.envelopeTable2012Jan },
          { amount: model?.envelopeTable2012Feb },
          { amount: model?.envelopeTable2012Mar },
          { amount: model?.envelopeTable2012Apr },
          { amount: model?.envelopeTable2012May },
          { amount: model?.envelopeTable2012Jun },
          { amount: model?.envelopeTable2012Jul },
          { amount: model?.envelopeTable2012Aug },
          { amount: model?.envelopeTable2012Sep },
          { amount: model?.envelopeTable2012Oct },
          { amount: model?.envelopeTable2012Nov },
          { amount: model?.envelopeTable2012Dec },
        ],
      },
      {
        year: 2013,
        data: [
          { amount: model?.envelopeTable2013Jan },
          { amount: model?.envelopeTable2013Feb },
          { amount: model?.envelopeTable2013Mar },
          { amount: model?.envelopeTable2013Apr },
          { amount: model?.envelopeTable2013May },
          { amount: model?.envelopeTable2013Jun },
          { amount: model?.envelopeTable2013Jul },
          { amount: model?.envelopeTable2013Aug },
          { amount: model?.envelopeTable2013Sep },
          { amount: model?.envelopeTable2013Oct },
          { amount: model?.envelopeTable2013Nov },
          { amount: model?.envelopeTable2013Dec },
        ],
      },
      {
        year: 2014,
        data: [
          { amount: model?.envelopeTable2014Jan },
          { amount: model?.envelopeTable2014Feb },
          { amount: model?.envelopeTable2014Mar },
          { amount: model?.envelopeTable2014Apr },
          { amount: model?.envelopeTable2014May },
          { amount: model?.envelopeTable2014Jun },
          { amount: model?.envelopeTable2014Jul },
          { amount: model?.envelopeTable2014Aug },
          { amount: model?.envelopeTable2014Sep },
          { amount: model?.envelopeTable2014Oct },
          { amount: model?.envelopeTable2014Nov },
          { amount: model?.envelopeTable2014Dec },
        ],
      },
      {
        year: 2015,
        data: [
          { amount: model?.envelopeTable2015Jan },
          { amount: model?.envelopeTable2015Feb },
          { amount: model?.envelopeTable2015Mar },
          { amount: model?.envelopeTable2015Apr },
          { amount: model?.envelopeTable2015May },
          { amount: model?.envelopeTable2015Jun },
          { amount: model?.envelopeTable2015Jul },
          { amount: model?.envelopeTable2015Aug },
          { amount: model?.envelopeTable2015Sep },
          { amount: model?.envelopeTable2015Oct },
          { amount: model?.envelopeTable2015Nov },
          { amount: model?.envelopeTable2015Dec },
        ],
      },
      {
        year: 2016,
        data: [
          { amount: model?.envelopeTable2016Jan },
          { amount: model?.envelopeTable2016Feb },
          { amount: model?.envelopeTable2016Mar },
          { amount: model?.envelopeTable2016Apr },
          { amount: model?.envelopeTable2016May },
          { amount: model?.envelopeTable2016Jun },
          { amount: model?.envelopeTable2016Jul },
          { amount: model?.envelopeTable2016Aug },
          { amount: model?.envelopeTable2016Sep },
          { amount: model?.envelopeTable2016Oct },
          { amount: model?.envelopeTable2016Nov },
          { amount: model?.envelopeTable2016Dec },
        ],
      },
      {
        year: 2017,
        data: [
          { amount: model?.envelopeTable2017Jan },
          { amount: model?.envelopeTable2017Feb },
          { amount: model?.envelopeTable2017Mar },
          { amount: model?.envelopeTable2017Apr },
          { amount: model?.envelopeTable2017May },
          { amount: model?.envelopeTable2017Jun },
          { amount: model?.envelopeTable2017Jul },
          { amount: model?.envelopeTable2017Aug },
          { amount: model?.envelopeTable2017Sep },
          { amount: model?.envelopeTable2017Oct },
          { amount: model?.envelopeTable2017Nov },
          { amount: model?.envelopeTable2017Dec },
        ],
      },
      {
        year: 2018,
        data: [
          { amount: model?.envelopeTable2018Jan },
          { amount: model?.envelopeTable2018Feb },
          { amount: model?.envelopeTable2018Mar },
          { amount: model?.envelopeTable2018Apr },
          { amount: model?.envelopeTable2018May },
          { amount: model?.envelopeTable2018Jun },
          { amount: model?.envelopeTable2018Jul },
          { amount: model?.envelopeTable2018Aug },
          { amount: model?.envelopeTable2018Sep },
          { amount: model?.envelopeTable2018Oct },
          { amount: model?.envelopeTable2018Nov },
          { amount: model?.envelopeTable2018Dec },
        ],
      },
      {
        year: 2019,
        data: [
          { amount: model?.envelopeTable2019Jan },
          { amount: model?.envelopeTable2019Feb },
          { amount: model?.envelopeTable2019Mar },
          { amount: model?.envelopeTable2019Apr },
          { amount: model?.envelopeTable2019May },
          { amount: model?.envelopeTable2019Jun },
          { amount: model?.envelopeTable2019Jul },
          { amount: model?.envelopeTable2019Aug },
          { amount: model?.envelopeTable2019Sep },
          { amount: model?.envelopeTable2019Oct },
          { amount: model?.envelopeTable2019Nov },
          { amount: model?.envelopeTable2019Dec },
        ],
      },
      {
        year: 2020,
        data: [
          { amount: model?.envelopeTable2020Jan },
          { amount: model?.envelopeTable2020Feb },
          { amount: model?.envelopeTable2020Mar },
          { amount: model?.envelopeTable2020Apr },
          { amount: model?.envelopeTable2020May },
          { amount: model?.envelopeTable2020Jun },
          { amount: model?.envelopeTable2020Jul },
          { amount: model?.envelopeTable2020Aug },
          { amount: model?.envelopeTable2020Sep },
          { amount: model?.envelopeTable2020Oct },
          { amount: model?.envelopeTable2020Nov },
          { amount: model?.envelopeTable2020Dec },
        ],
      },
    ];
    CalculatorUtility.setEnvelopeTableShowImage(data, true);
    return data;
  }
}
